import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const temarioItems = [{
  title: '⚽ Manual del Enganche — Tomo 1: Fundamentos',
  description: 'Bases técnicas y tácticas esenciales para dominar la posición de enganche desde cero.'
}, {
  title: '🎯 Manual del Enganche — Tomo 2: Recepción y Control',
  description: 'Técnicas avanzadas de primer toque, control orientado y recepción bajo presión.'
}, {
  title: '👁️ Manual del Enganche — Tomo 3: Visión Periférica',
  description: 'Desarrollá la capacidad de leer el juego y anticipar movimientos antes de recibir.'
}, {
  title: '🏃 Manual del Enganche — Tomo 4: Desmarques',
  description: 'Movimientos inteligentes para crear espacios y recibir en zonas peligrosas.'
}, {
  title: '🥅 Manual del Enganche — Tomo 5: Definición',
  description: 'Técnicas de finalización, toma de decisiones en el área y ejecución bajo presión.'
}, {
  title: '👑 Manual del Enganche — Tomo 6: Liderazgo',
  description: 'Cómo dirigir al equipo, comunicar en cancha y tomar el control del partido.'
}, {
  title: '⚙️ Sistema de Tiros Libres — Tomo 1: Biomecánica',
  description: 'Fundamentos físicos del tiro libre: postura, contacto, seguimiento y generación de potencia.'
}, {
  title: '🔄 Sistema de Tiros Libres — Tomo 2: Tipos de Pelota Quieta',
  description: 'Dominio de diferentes técnicas: rosca, remate raso, tiro por encima, efecto lateral.'
}, {
  title: '🧤 Sistema de Tiros Libres — Tomo 3: Barrera y Arquero',
  description: 'Lectura del arquero rival, análisis de la barrera y selección del tipo de tiro.'
}, {
  title: '📅 Sistema de Tiros Libres — Tomo 4: Entrenamiento y Rutina',
  description: 'Programa completo de práctica, ejercicios progresivos y rutina de calentamiento.'
}];
export function Temario() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white py-16 md:py-24" data-id="element-145">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-146">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-147">
          Contenido Completo del Sistema
        </motion.h2>

        <div className="space-y-3" data-id="element-148">
          {temarioItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-149">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors" data-id="element-150">
                <div className="flex items-center gap-4" data-id="element-151">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-emerald-600 text-white font-bold text-sm flex-shrink-0" data-id="element-152">
                    {index + 1}
                  </span>
                  <span className="text-left font-semibold text-gray-900" data-id="element-153">
                    {item.title}
                  </span>
                </div>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-154" />
              </button>

              <AnimatePresence data-id="element-155">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-156">
                    <div className="px-6 py-4 bg-gray-50 border-t border-gray-200" data-id="element-157">
                      <p className="text-gray-700" data-id="element-158">{item.description}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}